import React, { FunctionComponent, ReactNode } from 'react';
import classes from './PageDecorator.module.scss';

type Props = {
    children?: ReactNode;
};

const PageDecorator: FunctionComponent<Props> = (props: Props) => {
    return (
        <div
            id="page"
            className={classes.PageDecorator}
        >
            {props.children}
        </div>
    );
};

export default PageDecorator;
